import { render, staticRenderFns } from "./AgentDeals.vue?vue&type=template&id=66bf366a&"
import script from "./AgentDeals.vue?vue&type=script&lang=js&"
export * from "./AgentDeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports